/* eslint-disable node/no-process-env */

export default {
    nodeEnv: (process.env.NODE_ENV ?? ''),
    serverAddress: (process.env.REACT_APP_SERVER_ADDRESS ?? ''),
    discordClientId: (process.env.REACT_APP_DISCORD_CLIENT_ID ?? ''),
} as const;
